import { HttpClient, HttpContext } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { map, Observable } from 'rxjs'
import { PARSE_DATE_PROPS } from 'src/app/shared/interceptors/date-interceptor'
import { APIEnvelope } from 'src/app/shared/models/api'
import {
  filter,
  FilterParams,
  httpParams,
  withHttpParams,
} from 'src/app/shared/utilities/http-params'

export type ScheduledEventCategory =
  | 'mdma_aggregation'
  | 'tbill_aggregation'
  | 'testing'

export type ScheduledEvent = Readonly<{
  category: ScheduledEventCategory
  event_timestamp: Date | null
  cron_expression: string | null
  user_name: string | null
  parameters: Readonly<Record<string, string>> | null
  repeatable: boolean
  type: string
  id: string
  event_status: string
  workflow: string
}>

export type ScheduleRequest = Readonly<{
  category: ScheduledEventCategory
  event_timestamp: string
  parameters: Record<string, string>
}>

type ScheduleSettlementRunEvent = Readonly<{
  category: ScheduledEventCategory
  settlement_type: string
  event_timestamp: Date
  operating_date: Date
}>

export type ScheduleMDMASettlementRunEvent = ScheduleSettlementRunEvent & Readonly<{
  category: 'mdma_aggregation',
}>

export type ScheduleTBillSettlementRunEvent = ScheduleSettlementRunEvent & Readonly<{
  category: 'tbill_aggregation',
  billing_month: Date
}>

@Injectable({ providedIn: 'root' })
export class SchedulingService {
  private readonly http = inject(HttpClient)

  get(
    filters: readonly FilterParams[],
  ): Observable<ScheduledEvent[]>{
    const params = httpParams(
      withHttpParams(filter, filters),
    )
    return this.http.get<APIEnvelope<ScheduledEvent>>('scheduling', {
      params,
      context: new HttpContext().set(PARSE_DATE_PROPS, ['event_timestamp']),
    }).pipe(map(res => res.results))
  }
  
  schedule(req: ScheduleRequest): Observable<unknown> {
    return this.http.post('scheduling', {
      ...req,
      repeatable: false,
      cron_expression: null,
      type: 'databricks',
    })
  }

  delete(category: string, id: string) {
    return this.http.delete(`scheduling/${category}/${id}`)
  }
}
